import { motion } from "framer-motion";

export const ChapterHead = ({ chapter, label, title, dark = false }) => (
    <div className="mb-10">
        <motion.p
            initial={{ opacity: 0, x: -16 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className={`flex items-center gap-3 text-xs font-extrabold uppercase tracking-[0.3em] ${dark ? "text-[#faff00]" : "text-[#f23218]"}`}
            data-testid={`chapter-label-${label.toLowerCase().replace(/\s/g, "-")}`}
        >
            <span className={`font-display text-2xl italic ${dark ? "text-[#fbf3e8]/40" : "text-[#1b0b06]/25"}`}>{chapter.replace(/\D/g, "").padStart(2, "0")}</span>
            {label}
        </motion.p>
        <motion.h2
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className={`font-display mt-3 max-w-2xl text-4xl font-black leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl ${dark ? "text-[#fbf3e8]" : "text-[#1b0b06]"}`}
        >
            {title}
        </motion.h2>
    </div>
);
